var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212C3D",
    fillRule: "nonzero",
    d: "M18.063 5.25h-1.688V3.562c0-.31-.252-.562-.563-.562H5.688C4.758 3 4 3.757 4 4.688V18.75C4 19.99 5.01 21 6.25 21h11.813c.31 0 .562-.252.562-.563V5.813c0-.31-.252-.562-.563-.562zM15.25 17.063c0 .31-.252.562-.563.562h-6.75c-.31 0-.562-.252-.562-.563v-1.125c0-1.55 1.262-2.812 2.813-2.812h2.25c1.55 0 2.812 1.261 2.812 2.813v1.124zM9.062 9.75c0-1.24 1.01-2.25 2.25-2.25 1.241 0 2.25 1.01 2.25 2.25S12.553 12 11.313 12c-1.24 0-2.25-1.01-2.25-2.25zm6.188-4.5H5.687c-.31 0-.562-.252-.562-.563 0-.31.252-.562.563-.562h9.562V5.25z",
    transform: "translate(-4 -3)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.9a68b0a6.svg";
export { ForwardRef as ReactComponent };